"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.avatarSizeTypes = exports.avatarTypes = void 0;
var avatarTypes = {
  square: 'avatar-square',
  circle: 'avatar-circle'
};
exports.avatarTypes = avatarTypes;
var avatarSizeTypes = {
  large: {
    className: 'avatar-lg',
    px: 40
  },
  small: {
    className: 'avatar-sm',
    px: 24
  },
  default: {
    className: '',
    px: 32
  }
};
exports.avatarSizeTypes = avatarSizeTypes;